module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-ok/5.png?b1d08601215588a286b87a365c688698";